module.exports = __webpack_public_path__ + "img/22-d65d9c.png";